import {
  createFeatureSelector,
  createSelector,
  MemoizedSelector,
} from '@ngrx/store';
import { isEmpty } from 'ramda';
import { getCurrentLabelsJson } from '../labels/labels.selector';
import { flowType } from '../query-params/query-param.selectors';
import { Options, ServiceOptionsState } from './service-options.model';

const selectState = createFeatureSelector<ServiceOptionsState>(
  'serviceOptionsState'
);

export const serviceOptionsState = createSelector(
  selectState,
  (state: ServiceOptionsState) => state
);

export const serviceOptions = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.serviceOptions[0]
);

export const hasError = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.hasError
);

export const isServerDown = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) =>
    !state?.indicativeRateCountry && state?.isServerDown
);

export const cashOutCountries = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.cashOutCountries
);

export const getOptionsCountries: MemoizedSelector<any, any> = createSelector(
  flowType,
  serviceOptionsState,
  (flow, options) =>
    flow === 'withdraw' ? options?.cashOutCountries : options?.cashInCountries
);

export const countriesDetails = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.countriesDetails
);

export const cmsCountryDetails: MemoizedSelector<any, any> = createSelector(
  getOptionsCountries,
  getCurrentLabelsJson,
  (countries, labels) => {
    const labelCountries = labels?.labels?.stellar?.country;
    if (countries && labelCountries && !isEmpty(labelCountries)) {
      const countriesFromCMS = countries.map(
        (countryCode: any) => labelCountries[countryCode]
      );
      countriesFromCMS.sort((a: any, b: any) => {
        if (a.name < b.name) {
          return -1;
        } else if (a.name > b.name) {
          return 1;
        } else {
          return 0;
        }
      });
      return countriesFromCMS;
    }
    return countries;
  }
);

export const defaultCountry = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) =>
    state?.withdrawCountry ? state.withdrawCountry : state.depositCountry
);

export const getDefaultCurrencyCode = createSelector(
  serviceOptions,
  (state: Options) => state.localCurrencyCode
);
export const getIndicativeRateCountry = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.indicativeRateCountry
);

export const getSupportedCurrencyCodes = createSelector(
  serviceOptions,
  (state: Options) => state.payoutCurrencyCodes
);

export const getPayoutOptionCode = createSelector(
  serviceOptions,
  (state: Options) => state.payoutOptionCode
);

// export const isCashOutAllowed = createSelector(
//     serviceOptionsState,
//     (state: ServiceOptionsState) => state?.serviceOptions !== [] //if service are empty, assume Country does NOT support for CashOut and show error page to the User
// );

export const isCashOutAllowed = createSelector(
  serviceOptionsState,
  (state: ServiceOptionsState) => state?.isCashOutAllowed
);
